export enum StoreProductStatus {
  Default = 'DEFAULT',
  Pending = 'PENDING',
  LocationError = 'LOCATION_ERROR',
  Unbooked = 'UNBOOKED',
}
